import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProblemSection() {
  return <section className="py-20 relative" data-id="element-191">
      <div className="max-w-3xl mx-auto px-6 lg:px-8 text-center" data-id="element-192">
        <FadeIn data-id="element-193">
          <p className="text-xl md:text-2xl text-gray-300 leading-relaxed mb-12 font-light" data-id="element-194">
            Estás cansada de revisar tu teléfono cada 5 minutos. Ves el{' '}
            <span className="text-gold-400 font-medium" data-id="element-195">"En Línea"</span>, ves
            que leyó tu mensaje, pero el silencio de su parte es ensordecedor.
            Sientes que mientras más intentas acercarte, más rápido se aleja él.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-196">
          <p className="text-xl md:text-2xl text-gray-300 leading-relaxed mb-16 font-light" data-id="element-197">
            La realidad es cruda: en este momento, tú eres la que está
            invirtiendo todo y él es quien tiene el control total. <br data-id="element-198" />
            <span className="text-white font-serif italic text-2xl md:text-3xl mt-4 block" data-id="element-199">
              Pero eso se termina hoy.
            </span>
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-200">
          <div className="bg-dark-100 border border-gold-500/20 p-8 md:p-12 rounded-sm relative overflow-hidden" data-id="element-201">
            <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-gold-400 to-gold-600" data-id="element-202"></div>

            <h3 className="text-3xl font-serif text-white mb-6" data-id="element-203">
              La trampa de la{' '}
              <span className="text-gold-400" data-id="element-204">"Disponibilidad Total"</span>
            </h3>

            <p className="text-gray-400 text-lg leading-relaxed mb-6 text-left" data-id="element-205">
              Le has enseñado que no importa cómo te trate, siempre estarás ahí
              con un mensaje lindo o una buena cara. Tu ansiedad por no perderlo
              es precisamente lo que lo está empujando a los brazos de la
              indiferencia.
            </p>

            <p className="text-gray-400 text-lg leading-relaxed text-left" data-id="element-206">
              Él ya no te "ve" porque te has vuelto predecible. Eres como el
              aire: vital, pero{' '}
              <span className="text-white font-medium" data-id="element-207">
                nadie agradece que el aire esté ahí hasta que le falta.
              </span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}